import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

function selectFilterOption() {
    return true;
}

class OSVersionTypeahead extends Component {
    static propTypes = {
        labelId: PropTypes.string,
        osVersions: PropTypes.array.isRequired,
        required: PropTypes.bool,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        isMulti: PropTypes.bool,
        animatedPlaceholder: PropTypes.bool,
        renderSectionTitle: PropTypes.func,
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        labelId: 'osVersion',
        renderMultiSuggestion
    };

    constructor(props) {
        super(props);

        this.state = {
            options: props.osVersions
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getSuggestions = value => {
        const { osVersions } = this.props;
        const inputValue = value.trim().toLowerCase();
        const suggestions = !value ? osVersions : osVersions
            .filter(osVersion => osVersion
                .name
                .toLowerCase()
                .includes(inputValue)
            );

        if (this._isMounted)
            this.setState({ options: suggestions });
    };

    render() {
        const {
            required,
            error,
            labelId,
            isMulti,
            animatedPlaceholder,
            value,
            onChangeSuggestion,
            renderSectionTitle,
            renderMultiSuggestion,
            t
        } = this.props;

        const { options } = this.state;

        const formattedOptions = options.map(s => ({
            label: s.name,
            value: s.id
        }));

        return (
            <MultiTypeahead
                required={required}
                error={error}
                titleId={labelId}
                isMulti={isMulti}
                isClearable
                backspaceRemovesValue
                animatedPlaceholder={animatedPlaceholder}
                options={formattedOptions}
                value={value}
                handleSuggestionsFetchRequested={this.getSuggestions}
                onChangeSuggestion={onChangeSuggestion}
                selectFilterOption={selectFilterOption}
                formatGroupLabel={renderSectionTitle}
                formatOptionLabel={renderMultiSuggestion}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ infrastructure }) => ({
    osVersions: infrastructure.osVersions
});

export default compose(withTranslation('mobiledevices'), connect(mapStateToProps))(OSVersionTypeahead);
